// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main_box[data-v-fae5bece] {\n  width: 75vw;\n  margin: auto;\n  font-size: 1.4em;\n}\n.header[data-v-fae5bece] {\n  text-align: center;\n  margin-top: 5vh;\n  margin-bottom: 5vh;\n}\n.client_logo[data-v-fae5bece] {\n  width: 120px;\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
